import { ajaxURL } from "./variables";
import FormValidator from './FormValidator.js';
import spinner from './spinner.js';
import swal from 'sweetalert2';


window.addEventListener("load", function () {

    // const submitButton = document.getElementById('submit_screenshot_ajax');
    // const uploadResult = document.getElementById('upload-result');
    // const form = document.getElementById('steam-game-upload-form');




    // if(!form) return;

    // submitButton.addEventListener('click', async function(e) {
    //     e.preventDefault();

    //     const formData = new FormData();
    //     formData.append('action', 'handle_game_upload');
    //     formData.append('game_title', document.getElementById('game_title').value);
    //     formData.append('screenshot', document.getElementById('screenshot').files[0]);
    //     formData.append('nonce', document.getElementById('steam_game_upload_nonce').value);

    //     try {
    //         const response = await fetch(ajaxURL, {
    //             method: 'POST',
    //             body: formData
    //         });

    //         const result = await response.json();
    //         console.log(result);
    //         if (result.success) {
    //             uploadResult.innerHTML = `<p>${result.data.message}</p>`;
    //         } else {
    //             uploadResult.innerHTML = `<p>Error: ${result.data.message}</p>`;
    //         }
    //     } catch (error) {
    //         uploadResult.innerHTML = '<p>An error occurred during the upload.</p>';
    //     }
    // });

    // get .da__form da__form-game-screenshot-upload
    let form = document.querySelector('.da__form-game-screenshot-upload');
    if( !form ) return;

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        let messageDiv = form.closest('.da__form-wrapper').querySelector('.da__form-message');
        // clear the message div
        messageDiv.innerHTML = '';
        const validateForm = new FormValidator(form);

        // check if the form is valid
        if (validateForm.validate()) {
            // get message div
            // append the spinner to the form
            let spinnerDiv = document.createElement('div');
            spinnerDiv.classList.add('da__spinner');
            spinnerDiv.innerHTML = spinner;
            form.appendChild(spinnerDiv);
            // if the form is valid, we send the data to the server
            // we create a new FormData object and append the form data to it
            let data = new FormData(form);
            data.append('action', 'handle_game_upload');
            // we send the data to the server
            fetch(ajaxURL, {
                method: 'POST',
                body: data
            })
            .then(response => response.json())
            .then(data => {
                console.log(data);

                // remove the spinner from the form
                spinnerDiv.remove();
                if (data.success) {
                    
                    // if the server responds with success, we display the message

                    swal.fire({
                        title: 'Success',
                        text: data.data.message,
                        icon: 'success',
                        confirmButtonText: 'Close'
                    });
                    
                }else{
                    // if the server responds with an error, we log it
                    messageDiv.innerHTML = data.message;
                }
            })
            .catch(error => {
                console.log(error);
            });
        }
    });


});